import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ChatView from '../views/ChatView.vue'
import StatusesView from '../views/StatusesView.vue'
import UsersView from '../views/UsersView.vue'
import WelcomeView from '../views/WelcomeView.vue'
import DashboardView from '../views/DashboardView.vue'
import ChatsView from '../views/ChatsView.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    component: HomeView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'chats',
        component: ChatsView,
        children: [
          {
            path: '',
            name: 'welcome',
            component: WelcomeView
          },
          {
            path: 'chat/:id',
            name: 'chat',
            component: ChatView,
            props: true
          }
        ]
      },
      {
        path: 'statuses',
        name: 'statuses',
        component: StatusesView,
        meta: { requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'users',
        component: UsersView,
        meta: { requiresAdmin: true }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardView,
        meta: { requiresAdmin: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const isAuthenticated = store.getters.isAuthenticated
  const isAdmin = store.getters.isAdmin
  
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (requiresAdmin && !isAdmin) {
    next('/')
  } else if (to.path === '/login' && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
